import { Component, OnInit, TemplateRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DevicesService } from '../../../../app/core/routing/services/devices/devices.service';
import { DevicesConstants } from '../../../core/routing/services/devices/constants/devices.constants';
import { DeviceStoreService } from '../store/device.store';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

import { Device } from '../interface/devices-interface.i';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
@Component({
  selector: 'iposcen-push-update',
  templateUrl: './push-update.component.html',
  styleUrls: ['./push-update.component.scss']
})
export class PushUpdateComponent implements OnInit {
  @ViewChild('pushUpdateModal') modalContent: TemplateRef<PushUpdateComponent>;
  @Input() deviceInfo;
  @Output() readonly pushDone = new EventEmitter();
  @Input() deviceList;
  pushUpdateConfirm: boolean;
  isUpdatesPushed: boolean;
  deviceName: string;
  devices = DevicesConstants.DEVICES;
  pushUpdateToDevices = DevicesConstants.PUSH_UPDATES_TO_DEVICE;
  pushUpdateToSrtDevices = DevicesConstants.PUSH_UPDATES_TO_SRT_DEVICE;
  cancel = DevicesConstants.CANCEL;
  successMessage = DevicesConstants.UPDATES_PUSHED;
  pushUpdates = DevicesConstants.PUSH_UPDATES;
  allSelectedDevice = [];
  retailerId = sessionStorage.getItem('retailerId');
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  gaMetrics: object;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};

  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: NgbModal,
    private deviceStore: DeviceStoreService,
    private deviceservice: DevicesService) { }

  ngOnInit(): void {
    this.pushUpdateConfirm = true;
    this.isUpdatesPushed = false;
  }
  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.modalRef.dismiss();
  }
  dismissPushed() {
    this.modalRef.dismiss();
  }
  open(allSelectData, metrics) {
    Object.keys(metrics).forEach(key => {
      if (metrics[key]) {
        metrics[key] = 1;
      } else delete metrics[key]
    }
    )
    this.gaMetrics = Object.assign({}, metrics);
    //***Fix for IIT2-4230 starts***
    let checkString = GlobalConstants.CHROME;
    let result = allSelectData.filter(function (index) {
      return !(index.operatingSystem === checkString || index.operatingSystem === checkString.toLowerCase() || index.operatingSystem === checkString.toUpperCase());
    });
    let isChromeIncluded = (this.deviceList.length == result.length) ? true : false;
    if (!isChromeIncluded && (this.deviceStore.deviceStoreData.factTags !== undefined || this.deviceStore.deviceStoreData.bannerCarousels !== undefined)
      && (this.deviceStore.deviceStoreData.promotionalContents === undefined && this.deviceStore.deviceStoreData.segments === undefined
        && this.deviceStore.deviceStoreData.priceContents === undefined)) {
      this.allSelectedDevice = result.map(e => e.deviceID);
    } else this.allSelectedDevice = allSelectData.map(e => e.deviceID);
    //***Fix for IIT2-4230 ends***
    this.pushUpdateConfirm = true;
    this.deviceName = this.allSelectedDevice.length ? this.allSelectedDevice.toString() : this.deviceInfo.deviceName;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  submit() {
    if (this.userRole === GlobalConstants.SRT_ADMIN) {
      this.isUpdatesPushed = false;
      this.pushUpdateConfirm = false;
      this.pushDone.emit(true);
    } else {
      this.deviceStore.deviceStoreData.deviceIDs = this.allSelectedDevice.length ? this.allSelectedDevice : [this.deviceInfo.deviceID];
      this.deviceservice.updateAllDevices(this.deviceStore.deviceStoreData, this.retailerId)
        .pipe()
        .subscribe(res => {
        });
      const isMultipleDevice = this.deviceList.length > 1 ? true : false;
      this.googleAnalyticsService.pushUpdateDevice(isMultipleDevice, this.gaMetrics);
      this.isUpdatesPushed = false;
      this.pushUpdateConfirm = false;
      this.pushDone.emit(true);
      this.deviceStore.clearStoreData();
    }
  }
}
